import isHotkey from 'is-hotkey'

export function onEnter(event, callback) {
  if (isHotkey('enter', event)) {
    callback()
  }
}
